const editorRegistry = {}
const editorPromises = {}

export function registerEditor(pluginName, EditorComponent) {
  editorRegistry[pluginName] = EditorComponent
}

export function getEditor(pluginName) {
  return editorRegistry[pluginName] || null
}

export function getEditorAsync(pluginName) {
  // Return from cache if already registered synchronously
  if (editorRegistry[pluginName]) {
    return Promise.resolve(editorRegistry[pluginName])
  }

  // Return pending promise if already loading
  if (editorPromises[pluginName]) {
    return editorPromises[pluginName]
  }

  let loader
  switch (pluginName) {
    case 'intro-card':
      loader = import(/* webpackChunkName: "editor-intro-card" */ './introCardEditor')
      break
    case 'sorting':
      loader = import(/* webpackChunkName: "editor-sorting" */ './sortingEditor')
      break
    case 'interactive-path':
      loader = import(/* webpackChunkName: "editor-interactive-path" */ './interactivePathEditor')
      break
    case 'spreadsheet':
      loader = import(/* webpackChunkName: "editor-spreadsheet" */ './spreadsheetEditor')
      break
    case 'statement-table':
      loader = import(/* webpackChunkName: "editor-statement-table" */ './statementTableEditor')
      break
    case 'code-editor':
      loader = import(/* webpackChunkName: "editor-code-editor" */ './codeEditorEditor')
      break
    case 'process-flow':
      loader = import(/* webpackChunkName: "editor-process-flow" */ './processFlowEditor')
      break
    case 'facility-planner':
      loader = import(/* webpackChunkName: "editor-facility-planner" */ './facilityPlannerEditor')
      break
    case 'matching':
      loader = import(/* webpackChunkName: "editor-matching" */ './matchingEditor')
      break
    case 'stakeholder-dialogue':
      loader = import(/* webpackChunkName: "editor-stakeholder-dialogue" */ './stakeholderDialogueEditor')
      break
    case 'inbox-triage':
      loader = import(/* webpackChunkName: "editor-inbox-triage" */ './inboxTriageEditor')
      break
    case 'performance-review':
      loader = import(/* webpackChunkName: "editor-performance-review" */ './performanceReviewEditor')
      break
    case 'training-designer':
      loader = import(/* webpackChunkName: "editor-training-designer" */ './trainingDesignerEditor')
      break
    default:
      return Promise.resolve(null)
  }

  editorPromises[pluginName] = loader.then(() => {
    return editorRegistry[pluginName] || null
  })

  return editorPromises[pluginName]
}
